import {
  SET_TOPBAR_BOOKING_LINK,
  CLEAR_TOPBAR_BOOKING_LINK,
} from '../actions/topbarActions';

const initialState = {
  bookingLink: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TOPBAR_BOOKING_LINK:
      return { ...state, bookingLink: action.bookingLink || null };
    case CLEAR_TOPBAR_BOOKING_LINK:
      return { ...state, bookingLink: null };
    default:
      return state;
  }
}
